import { render, staticRenderFns } from "./team_show.vue?vue&type=template&id=0986337d&"
import script from "./team_show.vue?vue&type=script&lang=js&"
export * from "./team_show.vue?vue&type=script&lang=js&"
import style0 from "./team_show.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "team_show.vue"
export default component.exports